import React from "react";

import Box from "@mui/material/Box";

const CenteredBox = ({ display, children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexGrow: 1,
        flexDirection: display ?? "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </Box>
  );
};

export default CenteredBox;
